import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AgentsSelect from "../../../../../agents/components/agents-select.vue";
import { SEND_USER_DATA_REQUEST, LOAD_USER_DATA_REQUEST_DETAILS } from "../../store/application-actions";
import { mapActions, mapGetters, mapState } from "vuex";
import Err from "../../../../../../routes/error";
import HelloSign from "hellosign-embedded";
import SpinnerLoader from "@Shared/utils/preload";
import { PLAN_NAMES, showToast } from "@Shared/utils/constants";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import { GenericModal } from "@Shared/components/modals";
import AccountUsageBanner from "@Broker/@Modules/account-plan/components/account-plan-usage/account-usage-banner.vue";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import PlanSimpleButton from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-simple-button.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import { CLIENT_APPLICATION_OWNER_USERNAME } from "../../store/application-getters";
import NoaRequesterDropdownTemplate from "@Shared/@HandlebarsTemplates/general/_noa-requester-dropdown.hbs";
import { ACCOUNT_PLAN_IS_FREE, IS_LOCALE_EN } from "@Broker/@Modules/main/store/account/account-getters";
import { GET_AGENT } from "@Broker/@Modules/agents/store/agent-getters";
import { uniq } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CraRequestModal",
  components: {
    PlanSimpleButton,
    AgentsSelect,
    IncidentMessage,
    GenericModal,
    AccountUsageBanner,
    MaterialInput,
    ApplicantSelect
  },
  mixins: [validationMixin],
  provide() {
    return {
      formatSelect2Data: this.formatAgentSelectData
    };
  },
  validations: {
    requesterAgentOrDefault: {
      required
    },
    selectedApplicant: {
      required,
      email: {
        required,
        email
      }
    }
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    applicationInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      helloSignInstance: null,
      loading: false,
      requesterAgent: this.agentUsername,
      successfulRequest: false,
      noaDisabled: true,
      // TODO Hiding NOA functionality since MrTaxes no longer allowed to obtain it
      requesting: {
        loading: false,
        success: true
      },
      selectedApplicant: null,
      noaFailure: true // new variable to avoid unnecessary changes
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails"])), mapGetters("ApplicationStore", [CLIENT_APPLICATION_OWNER_USERNAME])), mapGetters("AccountStore", [ACCOUNT_PLAN_IS_FREE, IS_LOCALE_EN])), mapGetters("AgentStore", [GET_AGENT])), {}, {
    accountPlanPage() {
      return ACCOUNT_PLAN_PAGE.NOA;
    },
    requesterAgentOrDefault() {
      return this.requesterAgent || this.userDetails.username;
    },
    helloSignLocale() {
      if (this.$root.$i18n.locale === "fr-CA") {
        return HelloSign.locales.FR_FR;
      }
      return HelloSign.locales.EN_US;
    },
    ownerUsername() {
      return this.CLIENT_APPLICATION_OWNER_USERNAME({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    applicationOwner() {
      return this.GET_AGENT(this.ownerUsername) || {};
    },
    initiatorUsername() {
      return this.userDetails.username;
    },
    validAgentsForNoa() {
      var _context;
      return _filterInstanceProperty(_context = uniq([this.ownerUsername, this.initiatorUsername])).call(_context, Boolean);
    },
    disableRequestByPlan() {
      if (this.ownerUsername === this.initiatorUsername) return false;
      const initiatorIsPro = !this.ACCOUNT_PLAN_IS_FREE;
      const ownerIsFree = this.applicationOwner.accountPlan !== PLAN_NAMES.PRO;
      return initiatorIsPro && ownerIsFree;
    },
    tooltipMsg() {
      return this.$v.$invalid ? this.$t("noa-request.messages.invalidApplicantInfo") : "";
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), mapActions("ApplicationStore", [SEND_USER_DATA_REQUEST, LOAD_USER_DATA_REQUEST_DETAILS])), {}, {
    formatAgentSelectData(select2State) {
      return $(NoaRequesterDropdownTemplate(_objectSpread(_objectSpread({}, select2State), {}, {
        isOwner: this.ownerUsername === select2State.username,
        translations: {
          owner: this.$t("noa-request.messages.applicationOwner")
        }
      })));
    },
    async handleShow() {
      try {
        this.loading = true;
        await _Promise.all([this.LOAD_USER_DATA_REQUEST_DETAILS({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        }), this.LOAD_PLAN_LIMIT(this.accountPlanPage)]);
        this.loading = false;
      } catch (e) {
        Err.handle(e);
      }
    },
    async sendNOARequest() {
      try {
        this.requesting.loading = true;
        const {
          response
        } = await this.SEND_USER_DATA_REQUEST({
          applicationId: this.applicationId,
          data: {
            agentUsername: this.requesterAgentOrDefault,
            name: `${this.selectedApplicant["first-name"]} ${this.selectedApplicant["last-name"]}`,
            email: this.selectedApplicant.email
          },
          type: "noa",
          clientUsername: this.clientUsername
        });
        const {
          url,
          clientId
        } = response[0].value;
        this.successfulRequest = true;
        await this.$nextTick();
        await this.$nextTick();
        SpinnerLoader.start("#hellosign-iframe-wrapper");
        this.helloSignInstance = new HelloSign({
          clientId
        });
        this.helloSignInstance.open(url, {
          // eslint-disable-next-line no-undef
          skipDomainVerification: process.env.ENVIRONMENT !== "production",
          allowCancel: true,
          container: this.$refs.iframeWrapper,
          locale: this.helloSignLocale
        });
        this.helloSignInstance.on("ready", () => SpinnerLoader.stop());
        this.helloSignInstance.on("send", () => {
          showToast("success", "NOARequestSent");
          this.$hideModal();
        });
        this.requesting.success = true;
      } catch (e) {
        this.requesting.success = false;
        Err.handle(e);
        SpinnerLoader.stop();
      } finally {
        this.requesting.loading = false;
      }
    },
    handleChange({
      username: agent
    }, type) {
      switch (type) {
        case "select":
          this.requesterAgent = agent;
          break;
        case "unselect":
          this.requesterAgent = null;
      }
    },
    handleClose() {
      if (!this.successfulRequest && !this.noaFailure) {
        this.$refs.agentsSelect.reset();
      }
      this.close();
      this.requesterAgent = null;
      this.selectedApplicant = null;
      this.successfulRequest = false;
    },
    handleIncidentUpdate(hasIncident) {
      this.noaDisabled = hasIncident;
    },
    close() {
      var _this$helloSignInstan;
      (_this$helloSignInstan = this.helloSignInstance) == null ? void 0 : _this$helloSignInstan.close();
    }
  })
});